module.exports = __webpack_public_path__ + "static/media/manager.37bc3afd.svg";